import { services } from '~/config/constants';
import { WelfareAdminFilters, WelfareAdminPayload } from '~/types';
import API from './api';

const { welfareService } = services;

// Single source of truth for the admin-management base path. The backend routes
// are `/<user_id>/admin/welfare/...`; the FE convention inserts `/welfare-service`
// after the first segment (the api.ts interceptor strips the APP_ID baseURL for
// any URL containing `/welfare-service`).
const base = (id: string) => `${id}${welfareService}/admin/welfare`;

export const getMyWelfareRoles = async (id: string, token?: string) =>
    await API({
        endpoint: `${base(id)}/me`,
        method: 'GET',
        skipCache: true,
        token,
    });

export const getWelfareAdmins = async (id: string, filters: WelfareAdminFilters) =>
    await API({
        endpoint: `${base(id)}?search=${
            filters.search ? encodeURIComponent(filters.search) : ''
        }&limit=${filters.limit ?? 10}&skip=${filters.skip ?? 0}`,
        method: 'GET',
        skipCache: true,
    });

export const getWelfareAdminCandidate = async (id: string, email: string) =>
    await API({
        endpoint: `${base(id)}/candidate?email=${encodeURIComponent(email)}`,
        method: 'GET',
        skipCache: true,
    });

export const createWelfareAdmin = async (id: string, data: WelfareAdminPayload) =>
    await API({
        endpoint: base(id),
        method: 'POST',
        data,
    });

export const getWelfareAdmin = async (id: string, welfareAdminId: string) =>
    await API({
        endpoint: `${base(id)}/authorizations/${welfareAdminId}`,
        method: 'GET',
        skipCache: true,
    });

export const updateWelfareAdmin = async (
    id: string,
    welfareAdminId: string,
    data: Omit<WelfareAdminPayload, 'email'>
) =>
    await API({
        endpoint: `${base(id)}/authorizations/${welfareAdminId}`,
        method: 'PUT',
        data,
    });

export const deleteWelfareAdmin = async (id: string, welfareAdminId: string) =>
    await API({
        endpoint: `${base(id)}/authorizations/${welfareAdminId}`,
        method: 'DELETE',
    });
